import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["autoFocus", "dataKey", "disabled", "inputMode", "dataSelenium", "isInvalid", "isValid", "name", "onChange", "placeholder", "renderExtraIcons", "type", "value", "displayMode", "onFocus", "onBlur"];
import { forwardRef } from 'react';
import { useResponsiveness } from '../responsiveness/ResponsivenessProvider';
import { SignupDataInputIcon } from '../views/Forms.styles';
import { DisplayMode } from './DisplayMode';
import { MigratedInputStyles } from './TextInput.styles';
import { TextInput as BaseTextInput } from 'foundations-components/transitional/components/TextInput';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const dynamicFontSize = (length, isMobile) => {
  const lengthToFontMap = isMobile ? {
    38: 15,
    34: 16,
    33: 17,
    30: 18,
    26: 20
  } : {
    44: 17,
    39: 18,
    37: 19,
    32: 20
  };
  const lengthUpperBracket = Object.keys(lengthToFontMap).map(Number).sort((a, b) => b - a).find(maxLength => length > maxLength);
  if (!lengthUpperBracket) {
    return 0;
  }
  return lengthToFontMap[lengthUpperBracket];
};
const TextInput = /*#__PURE__*/forwardRef((_ref, ref) => {
  let {
      autoFocus,
      dataKey,
      disabled,
      inputMode,
      dataSelenium,
      isInvalid,
      isValid,
      name,
      onChange,
      placeholder,
      renderExtraIcons,
      type,
      value,
      displayMode = DisplayMode.Label,
      onFocus,
      onBlur
    } = _ref,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded);
  const {
    isMobile
  } = useResponsiveness();
  return /*#__PURE__*/_jsxs(MigratedInputStyles, {
    disabled: disabled,
    error: isInvalid,
    id: "emailDivSelector",
    inputFontSize: dynamicFontSize(value ? value.length : placeholder.length, isMobile),
    success: isValid,
    children: [/*#__PURE__*/_jsx(BaseTextInput, Object.assign({
      autoComplete: type === 'password' ? 'new-password' : 'on',
      autoFocus: autoFocus,
      "data-selenium": dataSelenium || dataKey,
      disabled: disabled,
      inputMode: inputMode,
      inputRef: ref,
      name: name
    }, displayMode === DisplayMode.Placeholder ? {
      placeholder
    } : null, {
      styled: false,
      type: type,
      value: value,
      onBlur: event => {
        if (onBlur) {
          onBlur(event, dataKey);
        }
      },
      onChange: ({
        target
      }) => onChange(target.value),
      onFocus: onFocus
    }, rest)), renderExtraIcons && /*#__PURE__*/_jsx(SignupDataInputIcon, {
      children: renderExtraIcons()
    })]
  });
});
export default TextInput;